// File path: src/services/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC_egp5RtBhjYiOteUQICEGnmXuHSiMO00",
  authDomain: "cloud-archive-7129d.firebaseapp.com",
  projectId: "cloud-archive-7129d",
  storageBucket: "cloud-archive-7129d.firebasestorage.app",
  messagingSenderId: "722549904996",
  appId: "1:722549904996:web:7afa5d2526e00a9b9a7171",
  measurementId: "G-6S5BSBRYML",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);




export { auth };
